import { supabase } from './supabaseClient';

/** クーポンコードを適用する（設定画面「クーポンコード」欄から） */
export async function redeemCoupon(code) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('ログインが必要です');

  const res = await fetch('/api/redeem-coupon', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify({ code }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `適用に失敗しました（${res.status}）`);
  return data;
}

/** 発行済みクーポンの一覧を取得する（設定画面の管理者用フォームから・is_adminのみ） */
export async function listCoupons() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('ログインが必要です');

  const res = await fetch('/api/list-coupons', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `取得に失敗しました（${res.status}）`);
  return data.coupons || [];
}

/** クーポンコードを発行する（設定画面の管理者用フォームから・is_adminのみ） */
export async function issueCoupon({ code, type, extendDays, maxUses, note }) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('ログインが必要です');

  const res = await fetch('/api/issue-coupon', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify({ code, type, extendDays, maxUses, note }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `発行に失敗しました（${res.status}）`);
  return data;
}
